// import dotenv from 'dotenv'
import config from "../firebaseConfig.json";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
const firebaseConfig = config;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth: any = getAuth(app);
const db: any = getFirestore(app);
const storage: any = getStorage(app);

export { auth, db, storage };
